import {
  isOnline,
  isDocumentVisible,
  registerOnFocus,
  registerOnReconnect
} from "../utils/browser.helpers";
import { serializeQueryParams } from "./utils";
import { memoryCache } from "./memory.cache";
import { DataService } from "./data.service";

let cancelMap = new Map();
let revalidateOnFocusMap = new Map();
let revalidateOnReconnectMap = new Map();

function revalidate(revalidators) {
  if (!isDocumentVisible() || !isOnline()) return;
  console.info("calling revalidate list ", revalidators);

  for (const key of revalidators.keys()) {
    revalidators.get(key)?.map((cacheDSObj) => cacheDSObj.makeRequest());
  }
}

//will be called when window get focussed
registerOnFocus(() => {
  revalidate(revalidateOnFocusMap);
});

//will be called when network get reconnected
registerOnReconnect(() => {
  revalidate(revalidateOnReconnectMap);
});

function clearMapValues(map, key, value) {
  let arr = map.get(key) || [];
  arr = value ? arr.filter((entry) => entry !== value) : [];
  map.set(key, arr);
}

class CacheDataProvider {
  constructor({ key = "", url = "", params = { query: {} }, config = {} }) {
    this.key = key;
    this.config = config;
    this.url = url;
    this.params = params;
    if (this.key && config.revalidateOnFocus) {
      let arr = revalidateOnFocusMap.get(this.key) || [];
      arr.push(this);
      revalidateOnFocusMap.set(this.key, arr);
    }

    if (this.key && config.revalidateOnReconnect) {
      let arr = revalidateOnReconnectMap.get(this.key) || [];
      arr.push(this);
      revalidateOnReconnectMap.set(this.key, arr);
    }
  }

  makeRequest() {
    console.info("make requst is calling");
    let [req, cancelReqCb] = DataService.get(this.url, this.params);

    this.cancelReqCb = cancelReqCb;

    this.loadingCb?.(true);
    const serializedUrl = serializeQueryParams(this.url, this.params.query);
    const cacheMemory = memoryCache.get(serializedUrl);
    if (cacheMemory) {
      this.successCb(cacheMemory);
    }

    if (this.key) {
      //put the abortController in cache, so that it can be cancelled using key
      let cbList = cancelMap.get(this.key) || [];
      if (cbList.includes(this) === false) {
        cbList.push(this);
      }
      cancelMap.set(this.key, cbList);
    }

    req()
      .then((data) => {
        this.successCb(data);
        memoryCache.set(serializedUrl, data);
      })
      .catch((error) => {
        this.errorCb && this.errorCb(error);
      })
      .finally(() => this.loadingCb?.(false));
  }
  onError(cb) {
    this.errorCb = cb;
    return this;
  }
  onResponse(cb = () => {}) {
    this.successCb = cb;
    this.makeRequest();
    return this;
  }
  onLoading(cb) {
    this.loadingCb = cb;
    return this;
  }
  cancel() {
    this.cancelReqCb();
    this.errorCb && this.errorCb({});
    if (!this.key) return;

    clearMapValues(cancelMap, this.key, this);

    this.config.revalidateOnReconnect &&
      clearMapValues(revalidateOnReconnectMap, this.key, this);
    this.config.revalidateOnFocus &&
      clearMapValues(revalidateOnFocusMap, this.key, this);
  }
}

export const cancelAllRequestsByKey = (key) => {
  if (!key) return;
  let arr = cancelMap.get(key) || [];
  for (let cacheObj of arr) {
    cacheObj.cancel();
  }
};

export const CacheService = {
  get(config) {
    config = config || {
      key: "",
      url: "",
      params: { query: {} },
      config: {}
    };
    return new CacheDataProvider(config);
  }
};

//it will be used like this
// let reqObj = CacheService.get({
//   key: "",
//   url: "",
//   params: {},
//   config: {
//     revalidateOnFocus: true,
//     revalidateOnReconnect: true
//   }
// })
// .onResponse((data) => {})
// .onError((err) => {})
// .onLoading((state) => {});

//unmount
// reqObj.cancel();
